import { RefabricProURL } from "../index";
import { IWhatsNewFeedRequest, IWhatsNewFeedResponse, IWhatsNewSeenResponse, IWhatsNewToursResponse, IWhatsNewTourSeenResponse } from "./whatsNew.type";

// What's New feed + How-it-works tours. All endpoints are requireLogin; language is resolved
// server-side from the Accept-Language header, so the FE sends no locale param.
//
// NOTE: `HttpClient.get/post` return `response.data` (the JSON body), so these methods resolve to the
// body itself — read its fields directly (e.g. `res.items`), NOT `res.data.items`. The whats-new
// endpoints are flat (not wrapped in the `{ data, page }` envelope some other endpoints use). The
// `as unknown as` cast bridges HttpClient's blanket `ApiResponse<T>` return type to the real body.
export default {
  // Paginated announcements feed (newest first) + the per-user unread count. `page_size` max is 50
  // (BE 422s above that) — callers stay within it.
  async getFeed(params?: IWhatsNewFeedRequest, config?: { signal?: AbortSignal }): Promise<IWhatsNewFeedResponse> {
    return RefabricProURL.get("whats-new", { params, ...config }) as unknown as Promise<IWhatsNewFeedResponse>;
  },

  // Marks every item read via a server-side per-user watermark (idempotent). Fired when the panel opens.
  async markSeen(): Promise<IWhatsNewSeenResponse> {
    return RefabricProURL.post("whats-new/seen", {}, {}) as unknown as Promise<IWhatsNewSeenResponse>;
  },

  // Map of page_key -> { id, seen } for the feature-page "How it works?" hero tours. Fetched once at boot.
  async getTours(config?: { signal?: AbortSignal }): Promise<IWhatsNewToursResponse> {
    return RefabricProURL.get("whats-new/tours", { ...config }) as unknown as Promise<IWhatsNewToursResponse>;
  },

  // Marks a single feature tour seen (only the auto-open path calls this; a manual hero click does not).
  async markTourSeen(pageKey: string): Promise<IWhatsNewTourSeenResponse> {
    return RefabricProURL.post(`whats-new/tours/${encodeURIComponent(pageKey)}/seen`, {}, {}) as unknown as Promise<IWhatsNewTourSeenResponse>;
  },
};
